import styled from "styled-components";
import ScrollContainer from "react-indiana-drag-scroll";
import { Container, Category, Content, Aside } from "./PostRender/style";

export const ReccommendedContainer = styled(Container)`
  padding-top: 24px;
  padding-bottom: 24px;
`;

export const H2 = styled.h2`
  margin-bottom: 16px;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: -0.02em;
`;
export const FlexDiv = styled.div`
  position: relative;
  display: flex;
  overflow: auto;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
`;

export const SlideContainer = styled(ScrollContainer)`
  display: flex;
  flex-wrap: nowrap;
`;

export const RecommendedPost = styled.div`
  width: 95.55%;

  background: #fff8f0;
  border-radius: 8px;
  padding: 20px 16px 16px;
  box-sizing: border-box;
  margin-right: 12px;
`;

export const RecmdCategory = styled(Category)`
  margin-bottom: 12px;

  & span {
    font-weight: 400;
    font-size: 12px;
    letter-spacing: -0.02em;

    &.category {
      border-radius: 4px;
      background: #ffe4c8;
      color: #4a5056;
      padding: 1px 4px;
    }

    &.createAt {
      color: #aeb5bc;
    }
  }
`;

export const RecmdContent = styled(Content)`
  width: 224px;
  height: 38px;
  font-size: 14px;
  margin-bottom: 16px;
  overflow: hidden;
  cursor: pointer;
  /* padding-right: 16px; */
  box-sizing: border-box;

  overflow: hidden;
  text-overflow: ellipsis;

  display: -webkit-box;
  -webkit-line-clamp: 2; /* 라인수 */
  -webkit-box-orient: vertical;
  word-break: break-word;
  line-height: 18px;
  height: 18px * 2;
`;

export const RecAside = styled(Aside)`
  margin: 0;

  & .aside__icons {
    & .likedDiv {
      display: flex;
    }

    & .orange {
      /* isLiked=true */
      color: #ff7a00;
      font-weight: 600;
      font-size: 12px;
      line-height: 20px;
    }
    & .balck {
      /* isLiked=false */
      font-size: 12px;
      line-height: 20px;
      color: #878e95;
    }
  }
`;
